import { render, staticRenderFns } from "./userProtocolDialog.vue?vue&type=template&id=5d7475e2&"
import script from "./userProtocolDialog.vue?vue&type=script&lang=js&"
export * from "./userProtocolDialog.vue?vue&type=script&lang=js&"
import style0 from "./userProtocolDialog.vue?vue&type=style&index=0&id=5d7475e2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports